var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-nav',{attrs:{"align":"center"}},[_c('b-nav-item',{attrs:{"href":"#what"}},[_vm._v("Descripción")]),_c('b-nav-item',{attrs:{"href":"#benefits"}},[_vm._v("Beneficios")]),_c('b-nav-item',{attrs:{"href":"#features"}},[_vm._v("Características")]),_c('b-nav-item',{attrs:{"href":"#plans"}},[_vm._v("Precios")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }